
import { Menu, Bell } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";

export default function AdminHeader({ onToggle }) {
  const { user } = useAuth();

  const initials = user?.email?.slice(0, 2).toUpperCase() || "AD";

  return (
    <header className="sticky top-0 z-30 flex h-16 w-full items-center justify-between border-b border-stone-200 bg-white px-4 shadow-sm sm:px-6">
      {/* Toggle sidebar */}
      <button
        type="button"
        onClick={onToggle}
        aria-label="Ouvrir ou fermer le menu"
        className="flex h-10 w-10 items-center justify-center rounded-xl text-stone-600 transition hover:bg-stone-100 hover:text-violet-600 focus:outline-none focus:ring-2 focus:ring-violet-500"
      >
        <Menu size={20} />
      </button>

      {/* Actions à droite */}
      <div className="flex items-center gap-3 sm:gap-5">
        {/* Lien vers le site client */}
        <Link
          to="/"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden text-sm font-medium text-violet-600 transition hover:text-violet-800 sm:inline-flex"
        >
          Voir le site <span className="ml-1">→</span>
        </Link>

        {/* Notifications */}
        <button
          type="button"
          aria-label="Notifications"
          className="relative flex h-10 w-10 items-center justify-center rounded-xl text-stone-600 transition hover:bg-stone-100 hover:text-violet-600 focus:outline-none focus:ring-2 focus:ring-violet-500"
        >
          <Bell size={19} />

          <span className="absolute right-2 top-2 h-2 w-2 rounded-full border-2 border-white bg-violet-600" />
        </button>

        {/* Avatar utilisateur */}
        <div
          title={user?.email || "Administrateur"}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-violet-100 bg-violet-100 text-xs font-bold text-violet-700 ring-2 ring-white"
        >
          {initials}
        </div>
      </div>
    </header>
  );
}
